document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-product-root]').forEach(root=>{
    const json=root.querySelector('[data-variants-json]');
    if(!json)return;
    const variants=JSON.parse(json.textContent);
    const idInput=root.querySelector('input[name="id"]');
    const price=root.querySelector('[data-product-price]');
    const compare=root.querySelector('[data-compare-price]');
    const add=root.querySelector('[data-add-to-cart]');
    const selected=[];
    root.querySelectorAll('[data-option-group]').forEach((group,index)=>{
      const current=group.querySelector('.is-selected')||group.querySelector('[data-option-value]');
      selected[index]=current?.dataset.optionValue;
      group.querySelectorAll('[data-option-value]').forEach(button=>button.addEventListener('click',()=>{
        group.querySelectorAll('[data-option-value]').forEach(x=>x.classList.remove('is-selected'));
        button.classList.add('is-selected');selected[index]=button.dataset.optionValue;sync();
      }));
    });
    function money(cents){return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(cents/100)}
    function sync(){
      const variant=variants.find(v=>v.options.every((o,i)=>o===selected[i]));
      if(!variant)return;
      idInput.value=variant.id;price.textContent=money(variant.price);
      if(compare){compare.textContent=variant.compare_at_price>variant.price?money(variant.compare_at_price):''}
      add.disabled=!variant.available;add.textContent=variant.available?'Add to basket':'Sold out';
      history.replaceState({},'',`${location.pathname}?variant=${variant.id}`);
    }
    sync();
  });
});
